document.addEventListener('DOMContentLoaded', function() {
  const megaMenuDetails = document.querySelector('.mega-menu');
  if (megaMenuDetails) {
    megaMenuDetails.addEventListener('toggle', function() {
      if (this.hasAttribute('open')) {
        const summary = this.querySelector('summary');
        const megaMenuContent = this.querySelector('.mega-menu__content');
        if (summary && megaMenuContent) {
          const rect = summary.getBoundingClientRect();
          megaMenuContent.style.top = `${rect.bottom}px`;
        }
      }
    });
  }
});
